import { Progress } from "antd";
import React, { useEffect, useState } from "react";
import {
  updateDisplayIdDrawer,
  updateShowPrimaryGuestDrawer,
} from "../../../../reducer/bookingReducer";
import { useSelector, useDispatch } from "react-redux";
import { customerByInvoiceId } from "../../../../services/customer";
import { Tooltip } from "@mui/material";
import { BsUpload } from "react-icons/bs";

const PrimaryGuest = ({ isBookingAlterationAllowed }) => {
  const {
    showMainBookingDetailsDrawer,
    invoiceDetails,
    customerDetails,
    bookingDetails,
  } = useSelector((store) => store.booking);

  const dispatch = useDispatch();

  const [customerArray, setCustomerArray] = useState({});
  const [totalCompleted, setTotalCompleted] = useState(0);

  useEffect(() => {
    if (invoiceDetails) performApi();
  }, [invoiceDetails, customerDetails]);

  const performApi = async () => {
    const roomBill = invoiceDetails?.find(
      (Obj) => Obj?.invoiceType === "roomBill"
    );

    let response = await customerByInvoiceId(roomBill?.id);

    if (Array.isArray(response?.data)) {
      let tempCustArray = response?.data?.map((Obj) => Obj?.customerDetails);
      tempCustArray?.push({
        name: `${bookingDetails?.adults ?? 1} Adults and ${
          bookingDetails?.childrens ?? 0
        } Minor `,
      });
      setCustomerArray(tempCustArray);
      completionChart(tempCustArray?.[0]);
    }
  };

  const completionChart = (data) => {
    let completed = 0;

    if (data?.phone) completed += 7.7;
    if (data?.name) completed += 7.7;

    if (data?.idImages?.length > 0) completed += 7.7;
    if (data?.email) completed += 7.7;

    if (data?.gender) completed += 7.7;

    if (data?.address) completed += 7.7;
    if (data?.country) completed += 7.7;

    if (data?.city) completed += 7.7;
    if (data?.zipCode) completed += 7.7;

    if (data?.dob) completed += 7.7;
    if (data?.company) completed += 7.7;
    if (data?.gstIN) completed += 7.7;
    if (data?.designation) completed += 7.7;

    setTotalCompleted(completed);
  };

  const handlePrimaryGuest = (type, customerId) => {
    if (!isBookingAlterationAllowed || !customerId) return;

    dispatch(
      updateShowPrimaryGuestDrawer({
        visible: true,
        bookingId: showMainBookingDetailsDrawer.bookingId,
        customerType: type,
        customerId: customerId,
      })
    );
  };

  const handleIdDrawer = async () => dispatch(updateDisplayIdDrawer());

  return (
    <div className="flex justify-between items-center font-outfit">
      <div className="flex gap-1 items-center ">
        <Progress
          type="circle"
          percent={Math.floor(totalCompleted)}
          size="small"
          strokeWidth={12}
          className="text-[#F36960] text-sm bg-transparent ml-2"
        />

        <div>
          <p className="text-[14px] font-[400] text-[#8F9BB3] ">
            Primary & attached guests
          </p>

          <div className="flex flex-wrap gap-[12px] pt-2 items-center">
            {Array.isArray(customerArray) ? (
              customerArray?.map((Obj) => {
                let name = Obj?.name ?? "";
                return (
                  <Tooltip
                    title={name?.length > 24 ? name?.split(0, 15) : ""}
                    className="cursor-pointer text-[#2F80ED] bg-[#526EFF0D] py-[4px] px-[10px] rounded-[5px] 
                      font-[500] text-[14px] "
                    onClick={() => handlePrimaryGuest("existing", Obj?.id)}
                  >
                    {name?.slice(0, 25) ?? ""}
                  </Tooltip>
                );
              })
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      {isBookingAlterationAllowed ? (
        <div
          className="cursor-pointer p-2 px-4 rounded-[6px] bg-[#E9F4FF]  
           flex items-center gap-4 "
          onClick={handleIdDrawer}
        >
          <span>
            {" "}
            <BsUpload className="text-[#007FFF] font-[500] text-[16px]" />{" "}
          </span>
          <span className="font-[500] text-[#007FFF] text-[0.75rem]  whitespace-nowrap ">
            Upload ID’s
          </span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default PrimaryGuest;
